export const openStyle = {
    background: '#D5F5E3',
    border: 'solid',
    borderWidth: '2px',
    borderColor: '#CCD1D1'

}

export const closedStyle = {
    background: '#FADBD8',
    border: 'solid',
    borderWidth: '2px',
    borderColor: '#CCD1D1'
}

export const blockedStyle = {
    background: '#FCF3CF',
    border: 'solid',
    borderWidth: '2px',
    borderColor: '#CCD1D1'
}

export const getRowStyle = (sortValue) => {
    switch (sortValue) {
        case 0:
            return closedStyle;
        case 1:
            return blockedStyle;
        case 2:
            return openStyle;
        default:
    }
}

export const getColumnStyle = (column) => {
    switch (column) {
        case 'status':
            return {
                width: '3%',
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
            }
        case 'number':
            return {
                width: '8%',
                padding: '0px 0px 0px 0px',
                textAlign: 'center'
            }
        case 'title':
            return {
                width: '50%',
                padding: '0px 0px 0px 5px',
                textAlign: 'center'
            }
        case 'severity':
            return {
                width: '5%',
                padding: '0px 0px 0px 5px',
                textAlign: 'center'
            }
        case 'created':
            return {
                width: '8%',
                padding: '0px 0px 0px 5px',
                textAlign: 'center'
            }
        case 'updated':
            return {
                width: '8%',
                padding: '0px 0px 0px 5px',
                textAlign: 'center'
            }
        case 'assignment':
            return {
                width: '10%',
                padding: '0px 0px 0px 5px',
                textAlign: 'center'
            }
        case 'release':
            return {
                width: '5%',
                padding: '0px 0px 0px 5px',
                textAlign: 'center'
            }
        default:
            return {}
    }
}


// WEBPACK FOOTER //
// ./src/js/styles/Display_Styles.js